import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalFooter, Row, Button } from "reactstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { TextInput } from "App/components/Inputs/BasicFormInputs.js";

const ManufacturerModal = ({
  edit = false,
  visible = false,
  setVisible,
  manufacturer = {},
  addManufacturer,
  editManufacturer,
  loading,
}) => {
  return (
    <Modal
      className="modal-dialog-centered formModal"
      isOpen={visible}
      data-testid="modal"
      backdrop="static"
    >
      {loading ? (
        <div className="d-flex justify-content-center my-5">
          <div className="spinner-border" manufacturer="status">
            <span className="sr-only">loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="modal-header">
            <h2 className="modal-title">
              {edit ? "Edit Manufacturer" : "Add Manufacturer"}
            </h2>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setVisible(false)}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <Formik
            enableReinitialize={true}
            initialValues={{
              name: manufacturer?.name || "",
            }}
            validationSchema={Yup.object({
              name: Yup.string()
                .required("Required")
                .max(200, "Cannot be longer than 200 characters"),
            })}
            onSubmit={(values, { setSubmitting }) => {
              if (edit) {
                console.log(manufacturer.id);
                editManufacturer({ id: manufacturer.id, ...values });
              } else addManufacturer(values);
            }}
          >
            {formikProps => {
              return (
                <>
                  <ModalBody>
                    <Form>
                      <Row>
                        <TextInput label="Name" name="name" col={12} />
                      </Row>
                    </Form>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      onClick={formikProps.submitForm}
                      color="primary"
                      type="submit"
                      data-testid="submitbutton"
                    >
                      {edit ? "Edit Manufacturer" : "Add Manufacturer"}
                    </Button>
                  </ModalFooter>
                </>
              );
            }}
          </Formik>
        </>
      )}
    </Modal>
  );
};

ManufacturerModal.propTypes = {
  edit: PropTypes.bool,
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  manufacturer: PropTypes.object,
  addManufacturer: PropTypes.func,
  editManufacturer: PropTypes.func,
  loading: PropTypes.bool,
};

export default ManufacturerModal;
